import { packageChargePlanActionTypes as actionTypes } from '../../ActionTypes/Voss/packageChargePlanActionTypes';
import { apiThunk } from '../../Utils/apiThunk';
import { mutatePackageResource, packageResourceUrl } from './packageResourceApi';
import type { AppDispatch } from '../../Store/types';
import type { CreatePackageChargePlanRequest, PackageChargePlan, UpdatePackageChargePlanRequest } from '../../Components/Voss/Packages/Packages.types';

const chargePlanUrl = (packageId: string, versionId: string | undefined, chargePlanId?: string) => packageResourceUrl(packageId, 'chargePlans', versionId, chargePlanId);

const fetchChargePlans = (packageId: string, versionId: string | undefined) => (dispatch: AppDispatch) =>
    dispatch(apiThunk<PackageChargePlan[]>(chargePlanUrl(packageId, versionId), { loadingKey: 'packageChargePlans' })).then((data) => {
        if (data !== null) dispatch({ type: actionTypes.STORE_PACKAGE_CHARGE_PLANS, data: { versionId, chargePlans: data } });
    });

// resolves once the reload has landed, so a closed editor can't be reopened on the list from before the write
const writeAndReload = (packageId: string, versionId: string | undefined, url: string, init: RequestInit) => async (dispatch: AppDispatch) => {
    const succeeded = await dispatch(mutatePackageResource(url, init));
    if (succeeded) await dispatch(fetchChargePlans(packageId, versionId));

    return succeeded;
};

const packageChargePlanActions = {
    fetchChargePlans,

    clearChargePlans() {
        return { type: actionTypes.CLEAR_PACKAGE_CHARGE_PLANS };
    },

    createChargePlan(packageId: string, model: CreatePackageChargePlanRequest, versionId: string | undefined) {
        return writeAndReload(packageId, versionId, chargePlanUrl(packageId, versionId), { method: 'POST', body: JSON.stringify(model) });
    },

    updateChargePlan(packageId: string, chargePlanId: string, model: UpdatePackageChargePlanRequest, versionId: string | undefined) {
        return writeAndReload(packageId, versionId, chargePlanUrl(packageId, versionId, chargePlanId), { method: 'PUT', body: JSON.stringify(model) });
    },

    deleteChargePlan(packageId: string, chargePlanId: string, versionId: string | undefined) {
        return writeAndReload(packageId, versionId, chargePlanUrl(packageId, versionId, chargePlanId), { method: 'DELETE' });
    },
};

export default packageChargePlanActions;
